import { render, staticRenderFns } from "./DocumentGroup.vue?vue&type=template&id=01e9c6db&scoped=true&"
import script from "./DocumentGroup.vue?vue&type=script&lang=js&"
export * from "./DocumentGroup.vue?vue&type=script&lang=js&"
import style0 from "./DocumentGroup.vue?vue&type=style&index=0&id=01e9c6db&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01e9c6db",
  null
  
)

export default component.exports